// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

/* App Controllers */

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import LandingController from "./landing_controller"
application.register("landing", LandingController)

import ReadingController from "./reading_controller"
application.register("reading", ReadingController)

import ReadingStepsController from "./reading_steps_controller"
application.register("reading-steps", ReadingStepsController)

import ResizeController from "./resize_controller"
application.register("resize", ResizeController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import SettingsController from "./settings_controller"
application.register("settings", SettingsController)

import SelectSlideController from "./select_slide_controller"
application.register("select-slide", SelectSlideController)

import SharedModalController from "./shared_modal_controller"
application.register("shared-modal", SharedModalController)

import ShuffleController from "./shuffle_controller"
application.register("shuffle", ShuffleController)

import SlideCarouselController from "./slide_carousel_controller"
application.register("slide-carousel", SlideCarouselController)

import SplashScreenController from "./splash_screen_controller"
application.register("splash-screen", SplashScreenController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)

import ViewportHeightController from "./viewport_height_controller"
application.register("viewport-height", ViewportHeightController)

import ProfileTabsController from "./profile_tabs_controller"
application.register("profile-tabs", ProfileTabsController)
